import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { AUTH_ROUTES } from "@domains/auth/routes";
import { useEffect } from "react";
import { useVerifyAuthCodeMutation } from "@common/utils/graphql";
import { useAuthStore } from "@domains/auth/utils/useAuthStore";
import { FullPageLoader } from "@common/components/Loading/FullPageLoading";

export const AuthRedirectPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const code = searchParams.get("code");

  const setTokenState = useAuthStore((state) => state.setTokenState);
  const [verifyAuthCode] = useVerifyAuthCodeMutation();

  useEffect(() => {
    const verify = async () => {
      if (!code) {
        const authenticatedPath = location.pathname;
        const didManuallySignOut = authenticatedPath.includes(
          AUTH_ROUTES.SIGN_OUT.path,
        );
        const navigationOptions = { state: { from: authenticatedPath } };

        // if user did not manually sign out, redirect to login page with from = path to redirect to after login
        navigate(
          AUTH_ROUTES.LOGIN.path,
          didManuallySignOut ? undefined : navigationOptions,
        );
      } else {
        const redirectPath = searchParams.get("state");
        const { data } = await verifyAuthCode({ variables: { code } });
        if (
          data?.verifyAuthCode.__typename === "MutationVerifyAuthCodeSuccess"
        ) {
          const tokens = data.verifyAuthCode.data;
          setTokenState({
            ...tokens,
            isRefreshingToken: false,
          });
          // if redirect path is provided, navigate to it, otherwise navigate to home
          if (redirectPath) {
            navigate(redirectPath);
          } else {
            navigate("/home");
          }
        }
      }
    };

    verify();
  }, [code, location, searchParams, navigate, setTokenState, verifyAuthCode]);

  return (
    <div className="h-screen w-screen">
      <FullPageLoader />
    </div>
  );
};
